import { historicalIpoReturnsStatsElementOptions } from '../../../../historical-ipo-returns/constants/historicalIpoReturnsStatsElementOptions';

export const ipoReturnsStatsElementOptions = historicalIpoReturnsStatsElementOptions;
